import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["country", "alt", "className"];
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    minHeight: theme.spacing(2),
    minWidth: theme.spacing(2.75)
  }
}), {
  name: 'SD-PhoneFieldFlag'
});
export var PhoneFieldFlag = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      country,
      alt = country,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  if (country === 'AC' || country === 'BQ' || country === 'EH' || country === 'TA') {
    return /*#__PURE__*/_jsx(Typography, {
      ref: ref,
      variant: "h6",
      align: "center",
      component: "span",
      color: "textSecondary",
      className: clsx(styles.root, className),
      children: country
    });
  }
  return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, props), {}, {
    alt: alt,
    ref: ref,
    className: clsx(styles.root, className),
    src: "https://cdn.jsdelivr.net/gh/madebybowtie/FlagKit@2.2/Assets/SVG/".concat(country, ".svg")
  }));
});
if (process.env.NODE_ENV !== "production") PhoneFieldFlag.displayName = "PhoneFieldFlag";